export default __webpack_public_path__ + "static/media/clubChair.175e0fd9.png";